/* Browse by type — desktop drag-to-scroll
 *
 * Touch / trackpad already scroll natively. This adds click-and-drag for
 * fine pointers (mouse) so the strip matches the Pencil scroll UX on desktop.
 * Suppresses click on cards only after a real drag so links still navigate.
 */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 8;
  var INIT_FLAG = '__bbtDragInit';

  function init(scroller) {
    if (!scroller || scroller[INIT_FLAG]) return;
    scroller[INIT_FLAG] = true;
    scroller.classList.add('is-grabbable');

    var isDown = false;
    var didDrag = false;
    var suppressClick = false;
    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;
    var hasCapture = false;

    function onPointerDown(event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== undefined && event.button !== 0) return;

      isDown = true;
      didDrag = false;
      suppressClick = false;
      hasCapture = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
      // Do not setPointerCapture yet — capturing on every mousedown
      // breaks <a> navigation. Capture only after a real drag starts.
    }

    function onPointerMove(event) {
      if (!isDown || event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;

      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        suppressClick = true;
        scroller.classList.add('is-grabbing');
        try {
          scroller.setPointerCapture(event.pointerId);
          hasCapture = true;
        } catch (_) { /* no-op */ }
      }

      if (didDrag) {
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - dx;
      }
    }

    function release(event) {
      if (!isDown) return;
      if (event && pointerId !== null && event.pointerId !== pointerId) return;

      isDown = false;
      if (hasCapture) {
        try {
          if (pointerId !== null) scroller.releasePointerCapture(pointerId);
        } catch (_) { /* no-op */ }
      }
      hasCapture = false;
      pointerId = null;
      scroller.classList.remove('is-grabbing');
      didDrag = false;

      // If click never fires after a drag (e.g. released off-card), clear
      // the suppress flag so the next real click still navigates.
      if (suppressClick) {
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
      }
    }

    function onClickCapture(event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }

    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('pointermove', onPointerMove);
    scroller.addEventListener('pointerup', release);
    scroller.addEventListener('pointercancel', release);
    // Intentionally no pointerleave — it fires when cards toggle
    // pointer-events and was cancelling interactions mid-gesture.
    scroller.addEventListener('click', onClickCapture, true);
  }

  function initAll(root) {
    var ctx = root || document;
    var nodes = ctx.querySelectorAll('[data-browse-by-type-scroller]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
